export default "__VITE_ASSET__CWEGS0V3__"